import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch, Redirect } from 'react-router-dom';

import queryableHistory from './queryableHistory';

import store from 'store';

import { ToolsetLayout } from 'layouts';

import 'semantic-ui-css/components/transition.css';
import 'semantic-ui-css/components/dimmer.css';
import 'semantic-ui-css/components/modal.css';
import 'semantic-ui-css/components/reset.css';

import 'rc-slider/assets/index.css';

import 'styles/index.css';


const Application = () => (
  <div>
    <Switch>
      <Route path="/toolset" component={ToolsetLayout} />
      <Redirect to="/toolset" />
    </Switch>
  </div>
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={queryableHistory}>
      <Application />
    </ConnectedRouter>
  </Provider>,

  document.getElementById('root')
);
